export enum ProductSlidesTypeEnums {
  FAVORITOS = 'favoritos',
  OFERTAS = 'ofertas',
  OTROS = 'otros',
}
